import { render, staticRenderFns } from "./PatientViewQuizResults.vue?vue&type=template&id=839241e8"
import script from "./PatientViewQuizResults.vue?vue&type=script&lang=js"
export * from "./PatientViewQuizResults.vue?vue&type=script&lang=js"
import style0 from "./PatientViewQuizResults.vue?vue&type=style&index=0&id=839241e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports